import { style } from "@vanilla-extract/css";
import { theme } from "../../theme/css";

export const contentStyle = style({
  alignItems: "center",
  justifyContent: "center",
});

export const checkboxStyle = style({
  position: "absolute",
  top: theme.spacings.s,
  right: theme.spacings.s,
  pointerEvents: "none",
});

export const labelStyle = style({
  // maxWidth: "80%",
});
